/* =========================================================
   DH — Klarna OSM (PDP) — style override injected LAST
   - Removes white box
   - Smaller text
   - Closer to ATC button
   - Left aligned (RL-like)
   ========================================================= */
(function () {
  if (window.__DH_KLARNA_OSM_STYLE__) return;
  window.__DH_KLARNA_OSM_STYLE__ = true;

  var STYLE_ID = "dh-klarna-osm-style";

function css() {
  return `
/* =========================================================
   DH — Klarna OSM (PDP) — rem-based + full spacing control
   ========================================================= */

/* WRAPPER — vertical spacing control */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]{
  display:block;
  margin-top: var(--dh-klarna-mt, 0.375rem) !important;
  margin-bottom: var(--dh-klarna-mb, 0rem) !important;
}

/* CONTAINER — remove box + RL layout */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-container){
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  padding: 0 !important;

  display:flex !important;
  flex-direction: row !important;
  justify-content:flex-start !important;
  align-items:center !important;
  gap: var(--dh-klarna-gap, 0.375rem) !important;

  text-align:left !important;
  font-size: var(--dh-klarna-font, 0.625rem) !important;
  line-height: var(--dh-klarna-lh, 0.875rem) !important;
  color: var(--dh-klarna-color, var(--custom-color-text-muted, #16332e)) !important;
}

/* MESSAGE */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-message){
  margin:0 !important;
}

/* CTA */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-cta){
  background:none !important;
  border:0 !important;
  padding:0 !important;
  margin:0 !important;
  font:inherit !important;
  line-height:inherit !important;
  text-decoration: var(--dh-klarna-cta-decoration, underline) !important;
  text-underline-offset: var(--dh-klarna-underline-offset, 0.12em) !important;
  cursor:pointer !important;
}

/* LOGO */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-logo){
  font-size: var(--dh-klarna-logo-font, 0.6875rem) !important;
  line-height:inherit !important;
}
`;
}

  function inject() {
    try {
      var old = document.getElementById(STYLE_ID);
      if (old) old.remove();

      var s = document.createElement("style");
      s.id = STYLE_ID;
      s.textContent = css();
      document.head.appendChild(s);
    } catch (e) {}
  }

  function hasPlacement() {
    try {
      return !!document.querySelector(
        'klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]'
      );
    } catch (e) {
      return false;
    }
  }

  function init() {
    // Inject subito e poi ancora quando Klarna monta
    inject();

    var tries = 0;
    var t = setInterval(function () {
      tries += 1;
      if (hasPlacement()) {
        inject(); // reinietta "last" quando il blocco esiste
        clearInterval(t);
      }
      if (tries >= 80) clearInterval(t); // ~4s
    }, 50);

    // Se Klarna re-renderizza, reiniettiamo
    try {
      var mo = new MutationObserver(function () {
        if (hasPlacement()) inject();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function () {
    inject();
    setTimeout(inject, 150);
    setTimeout(inject, 450);
  });
})();
